// Contact form: vanilla DOM, no React. Wired in main.ts.
//
// ┌───────────────────────────────────────────────────────────────────────────┐
// │ EXERCISE — implement this yourself.                                        │
// │ The body of mountContactForm() has been removed on purpose.                │
// └───────────────────────────────────────────────────────────────────────────┘
//
// WHAT IT SHOULD DO
//   On submit: validate the form, build a JSON payload, POST it to the API,
//   show a status message, scroll to it on success, then reset the form.
//
// API ENDPOINT
//   POST  ${API_BASE}/contact
//   Headers:  Content-Type: application/json
//   Body:     JSON.stringify(payload)        (see payload shape below)
//
//   API_BASE = content of <meta name="sde-api-base" content="..."> in
//   inc/meta.html, falling back to "/api" when that tag is absent. In dev,
//   Vite proxies "/api" to the Express API (see vite.config.ts).
//
// PAYLOAD (maps form fields → API fields, trim every string)
//   name     ← input[name="name"]        (required)
//   email    ← input[name="email"]       (required)
//   tel      ← input[name="tel"]         (optional)
//   subject  ← input[name="subject"]     (required)
//   message  ← textarea[name="content"]  (required)  ← note: the field is "content"
//
// DOM ELEMENTS
//   #contactform     the <form>           (required — abort if missing)
//   #submit          the submit <button>  (disable while sending)
//   #contact-status  status line          (optional — create it above the form
//




export function mountContactForm(): void {
  document.getElementById("contactform")?.addEventListener("submit", (event) => {
    event.preventDefault();

    const feedback = document.getElementById("feedback");
    if (!feedback) return;

    const naam = document.querySelector<HTMLInputElement>("input[name='name']")?.value.trim();
    const email = document.querySelector<HTMLInputElement>("input[name='email']")?.value.trim();
    const telefoonnummer = document.querySelector<HTMLInputElement>("input[name='tel']")?.value.trim();
    const onderwerp = document.querySelector<HTMLInputElement>("input[name='subject']")?.value.trim();
    const bericht = document.querySelector<HTMLTextAreaElement>("textarea[name='content']")?.value.trim();

    if (!naam || !email || !onderwerp || !bericht) {
      feedback.innerHTML =
        '<div class="alert alert-danger" role="alert">Naam, e-mail, onderwerp en bericht zijn verplichte velden</div>';
      return;
    }

    const myJSON = JSON.stringify({
      name: naam,
      email: email,
      subject: onderwerp,
      message: bericht,
      tel: telefoonnummer,
    });

    // Same-origin: Caddy proxies /api/* to the Express API in prod/accept/dev,
    // and Vite proxies /api to localhost:3000 during local development.
    fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: myJSON,
    }).then((res) => {
      if (res.ok) {
        feedback.innerHTML =
          '<div class="alert alert-success" role="alert">Uw e-mail is succesvol verzonden</div>';
      } else {
        feedback.innerHTML =
          '<div class="alert alert-danger" role="alert">Er ging iets mis bij het verzenden. Probeer het later opnieuw.</div>';
      }
    });
  });
}
